import { Injectable } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { IuiModalWindowService } from '@itero/ui-components-angular/modal-window';
import { RestorativeExportModal, RestorativeExportModalData } from './restorativeExport.component';
import { ExportRequest } from '../orthoCadExport/orthoCadExport.service';
import { SettingsService } from '../settings.service';
import { ShellContextService } from 'app/services/shell-context/shell-context.service';
import { FaceliftQuery } from '@shared/facelift-store/facelift.query';
import { combineLatest, map, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RestorativeExportService {
	constructor(
		private readonly tlkModalWindowService: TlkModalWindowService,
		private readonly iuiModalWindowService: IuiModalWindowService,
		private readonly settingsService: SettingsService,
		private readonly shellContextService: ShellContextService,
		private readonly faceliftQuery: FaceliftQuery,
	) {}

	openRestorativeExportModal(caseTypeId: string, request: ExportRequest): void {
		combineLatest([
			this.shellContextService.selectedCompanyId$,
			this.faceliftQuery.isFaceliftEnabled$,
		]).pipe(
			take(1),
			switchMap(([companyId, isFaceliftEnabled]) =>
				this.settingsService.getSettings(companyId, true, false).pipe(
					map((settings) => ({ settings, isFaceliftEnabled })),
				),
			),
		).subscribe(({ settings, isFaceliftEnabled }) => {
			const data: RestorativeExportModalData = {
				caseTypeId: +caseTypeId,
				orderId: request.orderId,
				orderDetailsId: request.orderDetailsId,
				settings,
			};

			if (isFaceliftEnabled) {
				this.iuiModalWindowService.open<void>(RestorativeExportModal, {
					size: 'sm',
					disableClose: true,
					data,
				});
			} else {
				this.tlkModalWindowService.open<void>(RestorativeExportModal, {
					width: '480px',
					disableClose: true,
					data,
				});
			}
		});
	}
}
